const useOnyx = () => {
  return window.Onyx
}

export default useOnyx
